import api from './client'
import type { PricingTemplate, PricingTemplatePayload } from '../api'

export const pricingTemplateAdminApi = {
  list: async (): Promise<PricingTemplate[]> => {
    const response = await api.get<PricingTemplate[]>('/settings/pricing-templates')
    return response.data
  },

  get: async (id: string): Promise<PricingTemplate> => {
    const response = await api.get<PricingTemplate>(`/settings/pricing-templates/${id}`)
    return response.data
  },

  create: async (data: PricingTemplatePayload): Promise<PricingTemplate> => {
    const response = await api.post<PricingTemplate>('/settings/pricing-templates', data)
    return response.data
  },

  update: async (id: string, data: Partial<PricingTemplatePayload>): Promise<PricingTemplate> => {
    const response = await api.patch<PricingTemplate>(`/settings/pricing-templates/${id}`, data)
    return response.data
  },

  archive: async (id: string): Promise<PricingTemplate> => {
    const response = await api.post<PricingTemplate>(`/settings/pricing-templates/${id}/archive`)
    return response.data
  },

  restore: async (id: string): Promise<PricingTemplate> => {
    const response = await api.post<PricingTemplate>(`/settings/pricing-templates/${id}/restore`)
    return response.data
  },

  setDefault: async (id: string): Promise<PricingTemplate> => {
    const response = await api.post<PricingTemplate>(`/settings/pricing-templates/${id}/set-default`)
    return response.data
  },
}

export const pricingTemplateApi = {
  list: async (): Promise<PricingTemplate[]> => {
    const response = await api.get<PricingTemplate[]>('/reference/pricing-templates')
    return response.data
  },
}
